module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagitta/sge_lines-4745e7246e0870d93f123602f608e6aa.gif";